module.exports = __webpack_public_path__ + "assets/img/personal-portfolio-landing.8d20584b.png";